import React from 'react';
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
export default function PublicAPI() {
    return (React.createElement(SwaggerUI, { url: "https://api.tidbyt.com/swagger.json", tryItOutEnabled: true }));
}
